module.exports = __webpack_public_path__ + "static/media/photo.7166c630.jpeg";